<template>
  <div>
    <Header>
      Ustawienia
    </Header>

    <b-row>
      <b-col xl="6">
        <b-list-group flush>
          <inertia-link
            v-if="user.can_manage_users"
            :href="route('users.index')"
            class="list-group-item list-group-item-action"
          >
            <b-icon icon="people-fill" class="mr-2" />
            Użytkownicy
          </inertia-link>
          <inertia-link
            v-if="user.can_manage_barbers"
            :href="route('barbers.index')"
            class="list-group-item list-group-item-action"
          >
            <b-icon icon="scissors" class="mr-2" />
            Fryzjerzy
          </inertia-link>
          <inertia-link
            v-if="user.can_manage_contacts"
            :href="route('contacts.index')"
            class="list-group-item list-group-item-action"
          >
            <b-icon icon="person-lines-fill" class="mr-2" />
            Kontakty
          </inertia-link>
          <inertia-link
            v-if="user.can_manage_services"
            :href="route('services.edit')"
            class="list-group-item list-group-item-action"
          >
            <b-icon icon="receipt" class="mr-2" />
            Usługi
          </inertia-link>
        </b-list-group>
        
        <div class="mt-4">
          <install-pwa />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import InstallPwa from '@/Components/PWA/InstallPwa.vue'

export default {
  layout: Layout,
  components: {
    Header,
    InstallPwa
  },
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
}
</script>
